import { IAction } from 'core/interface/action';
import { ISharedLinks } from 'core/interface/candidate';

export const SAVE_VALUES = 'save-companies';
export const SAVE_PUBLIC_VALUES = 'save-public-companies';

const defaultState = {
  companies: null,
  publicCompanies: null
};

export const SaveCompanies = (value: any | number[]) => ({
  type: SAVE_VALUES,
  payload: value
});

export const SavePublicCompanies = (value: any | number[]) => ({
  type: SAVE_PUBLIC_VALUES,
  payload: value
});

const companiesReducer = (
  state = defaultState,
  action: IAction<any | number[]>
) => {
  switch (action.type) {
    case SAVE_VALUES:
      return {
        ...state,
        companies: action.payload
      };
    case SAVE_PUBLIC_VALUES:
      return {
        ...state,
        publicCompanies: action.payload
      };
    default:
      return state;
  }
};

export default companiesReducer;
